import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';

import { Affiliation } from '@/types/affiliation';
import { getFullName } from '@/utils/name';
import { SharedButton } from '@/components/shared/Button';

import * as styles from './DeleteMembership.module.scss';
import { Modal } from '@/components/shared/Modal';

type Props = {
  children?: never;
  affiliation: Affiliation;
  onClickDelete: (id: number) => void;
};

export const DeleteMembership: React.FC<Props> = ({
  affiliation,
  onClickDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const { admin, role } = affiliation;
  const adminFullName = getFullName(admin.firstName, admin.lastName);

  return (
    <>
      <button className={styles.root} onClick={open}>
        <FaTimes data-test="delete-affiliation" />
        <span>{t('ui.action.delete')}</span>
      </button>

      <Modal
        isOpen={isOpen}
        onClose={close}
        title={t('ui.confirm.deleteMembership')}
        buttons={
          <>
            <SharedButton
              dataTest="cancel"
              onClick={close}
              color="gray"
              buttonType="tight"
              fontSize="small"
              fontWeight="bold"
            >
              {t('ui.action.cancel')}
            </SharedButton>
            <SharedButton
              dataTest="execute"
              onClick={() => {
                onClickDelete(admin.id);
                close();
              }}
              color="red"
              buttonType="tight"
              fontSize="small"
              fontWeight="bold"
            >
              {t('ui.action.deleteNow')}
            </SharedButton>
          </>
        }
      >
        {adminFullName ? adminFullName : admin.email}（
        {t(`models.affiliation.roleType.${role}.name`)}）
      </Modal>
    </>
  );
};
